import { css } from '@/styled-system/css';

export const trustSignalText = css({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  margin: 0,
  color: 'text.subtle',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
  letterSpacing: 'body-sm',
});

export const trustSignalSegment = css({
  display: 'flex',
  alignItems: 'center',
});

export const trustSignalSeparator = css({
  color: 'border.neutral',
  marginInline: 'tightest',
});
